import { detailGenerator } from "./detail.hooks";
import { pagedGenerator } from "./paged.hooks";
export var hooksGenerator = function (params) { return ({
    useDetail: detailGenerator(params),
    usePaged: pagedGenerator(params),
}); };
